import { Injectable, HostListener } from '@angular/core';
import { Http, HttpModule, Headers, RequestOptions } from '@angular/http';
import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/firestore';
import * as _ from 'lodash';
declare var Stripe: any;

@Injectable()
export class UserService {

  analytics;
  db;
  profile: any;
  public stripe;
  stripeKey;

  constructor(public http?: Http) {
    this.db = firebase.firestore();
    _.forEach(firebase.apps, (instance) => {
      if (instance.name == 'bitl-it-analytics') {
        this.analytics = firebase.firestore(instance);
      }
    });
    this.stripeKey = location.origin.includes('localhost') ? 'pk_test_GmvKWChqlZl4KYqrHZVgAdqN' : 'pk_live_j9qWqiZoNX94SsiP0V7c1HSj'
    this.stripe = new Stripe(this.stripeKey);
  }

  login(email, password) {
    return firebase.auth().signInWithEmailAndPassword(email, password);
  }

  sendPasswordReset(email) {
    return firebase.auth().sendPasswordResetEmail(email)
  }

  setProfile(uid, profile) {
    return this.db.collection("profiles").doc(uid).set(profile)
  }

  updateProfile(profile) {
    if (!profile.$id) return;
    return this.db.collection("profiles").doc(profile.$id).update(profile)
  }

  async initProfile(uid) {
    let user = await this.db.collection("profiles").doc(uid).get()
    this.profile = user.data();
  }

  async getProfile(uid: any) {
    if (uid) {
      let user = await this.db.collection("profiles").doc(uid).get();
      return user.data();
    } else {
      return this.profile;
    }
  }

  observeProfile(uid: any) {
    return this.db.collection("profiles").doc(uid)
  }

  verifiedUser(uid, reload = false) {
    this.db.collection("profiles").doc(uid).update({isEmailVerified: true});
    if (reload) location.reload();
  }

  async getProfileByUsername(username) {
    username = username.toLowerCase();
    let user = await this.db.collection("profiles").where("usernameLower", "==", username).get();
    if (!user || !user.docs || !user.docs.length) {
      return null;
    } else {
      return user.docs[0].data();
    }
  }

  async getUserSettings(uid) {
    let settings = await this.db.collection("settings").doc(uid).get();
    return settings.data();
  }

  saveUserSettings(init = false, newSettings, uid) {
    if (init) {
      this.db.collection("settings").doc(uid).set(newSettings);
    } else {
      this.db.collection("settings").doc(uid).update(newSettings);
      // return settings.data();
    }
  }

  async deleteUser() {
    let user = firebase.auth().currentUser;
    await this.db.collection("profiles").doc(user.uid).collection("links").delete();
    await this.db.collection("profiles").doc(user.uid).delete();
    await this.db.collection("settings").doc(user.uid).delete();
    let storage = firebase.storage().ref();
    await storage.child(`images/${user.uid}/profile.png`).delete();
    await user.delete()
    return;
  }

  // Analytics (to eventually be moved to it's own service).
  async addView(uid) {
    let view = { createdAt: Date.now() };
    let increment = await this.analytics.collection("views").doc(uid).get()
    increment = increment.data() || {count: 0};
    increment.count++;
    increment.count == 1 ? this.analytics.collection("views").doc(uid).set(increment) : this.analytics.collection("views").doc(uid).update(increment);
    await this.analytics.collection("views").doc(uid).collection("views").doc().set(view)
  }

  async getViews(uid) {
    let views = await this.analytics.collection("views").doc(uid).get();
    return views.data() || {count: 0};
  }

  async getViewsWithinLastTwoWeeks(uid) {
    let oneWeekAgo = Date.now() - 604800;
    let twoWeeksAgo = Date.now() - 1209600;
    let views = await this.analytics.collection("views").doc(uid).collection("views").where("createdAt", ">", oneWeekAgo).get();
    if (!views || !views.docs || !views.docs.length) {
      return 0;
    } else {
      return views.docs.length;
    }
  }

  async addClick(linkId) {
    let click = { createdAt: Date.now() };
    let increment = await this.analytics.collection("clicks").doc(linkId).get()
    increment = increment.data() || {count: 0};
    increment.count++;
    increment.count == 1 ? this.analytics.collection("clicks").doc(linkId).set(increment) : this.analytics.collection("clicks").doc(linkId).update(increment);
    await this.analytics.collection("clicks").doc(linkId).collection("clicks").doc().set(click)
  }

  async getClicks(linkId) {
    let increment = await this.analytics.collection("clicks").doc(linkId).get()
    return increment.data() || {count: 0};
  }

  async getClicksWithinLastTwoWeeks(uid) {
    let oneWeekAgo = Date.now() - 604800;
    let twoWeeksAgo = Date.now() - 1209600;
    let clicks = await this.analytics.collection("clicks").doc(uid).collection("clicks").where("createdAt", "<", 1).get();
    if (!clicks || !clicks.docs || !clicks.docs.length) {
      return 0;
    } else {
      return clicks.docs.length;
    }
  }

  stripeTokenHandler(token, uid) {
    this.db.collection("settings").doc(uid).update({
      stripePayment: token,
    })
  }

  stripeCustomerHandler(customer, uid) {
    this.db.collection("settings").doc(uid).update({
      stripeCustomer: customer,
    })
  }

  stripePlanHandler(plan, uid) {
    this.db.collection("settings").doc(uid).update({
      stripePlan: plan,
    })
  }

  stripeSubscriptionHandler(subscription, uid) {
    this.db.collection("settings").doc(uid).update({
      stripeSubscription: subscription,
    })
  }

  cancelSubscription(uid) {
    this.db.collection("settings").doc(uid).update({
      stripeSubscription: null,
      stripePlan: null,
    })
  }

  async updateMailChimp() {
    const headers = new Headers();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Credentials', 'true');

    const options = new RequestOptions({headers: headers});
    let users = [];
    let querySnapshot = await this.db.collection("profiles").get();
      querySnapshot.forEach(async (doc) => {
        let user = doc.data();
        if (user.$id) {
          let isPro = await this.db.collection("settings").doc(user.$id).get();
          let snap = isPro.data();
          snap = !!(snap && snap.stripePlan);
          users.push({
            email: user.email,
            name: user.name,
            isPro: snap
          });
        //   mailchimp.post('/lists/82485e2de7/members/', {
        //     "email_address": user.email,
        //     "status": "subscribed",
        //     "merge_fields": {
        //       "FNAME": user.name,
        //       "LNAME": "",
        //       "PRO": isPro
        //     }
        //   });
        // }
      };
    })
    return users;
  }

}



// WEBPACK FOOTER //
// ./src/services/user.service.ts